<template>
  <div class="container">
    <div class="page relative-page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 1.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="description-container" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
        <div class="main-text">
          <div>GRAILS</div>
          <div>A Series of 4 One-of-a-kind Hand Painted Art Works by Melbourne, Australia Artist Kevin ‘Ohnoes’ Gold</div>
          <div>July 3 - August 3, 2025</div>
        </div>
      </div>
    </div>

    <div class="page">
      <div class="logo" style="width: 100px; height: 100px;">
        <lazy-image src="../img/grails/logo.jpg" alt="BuyNiceCards" />
      </div>

      <div>Grails</div>
      <div>Kevin Gold</div>
      <div>July 3 - August 3, 2025</div>

      <p>
        Kevin 'Ohnoes' Gold is a Melbourne-based visual artist whose dynamic portraiture explores the intersection of athleticism,
        identity, and contemporary culture. With over a decade of experience, Gold has built an international reputation for his bold,
        energetic works that capture the spirit of athletes, musicians, and cultural icons through a vivid, street-inspired aesthetic.
        Influenced by both the urban landscapes of his native Melbourne and his deep personal connection to sport, Gold's paintings blend
        traditional portrait techniques with graffiti textures, layered brushwork, and vibrant color fields. His visual language evokes
        movement, intensity, and reverence—turning athletes into modern archetypes.
      </p>

      <p>
        Gold's work has garnered the attention of some of the biggest names in global sport, with commissioned portraits for figures such
        as Shaquille O'Neal, Dirk Nowitzki, Ben Simmons, Devin Haney, Seth Curry, Matisse Thybulle, and George Kambosos. In 2018,
        he was named a <b>finalist in the Shirley Hannan National Portrait Prize</b>, one of Australia's most respected portrait competitions, for
        his painting of NBA star Ben Simmons.
      </p>

      <p>Over the years, Gold’s artwork has featured in numerous exhibitions both nationally and abroad. Select shows include:</p>
      <p><b>"In the paint" TLG - Toronto 2025</b></p>
      <p><b>"BULLSH!T" Chicago bulls themed show - Melbourne 2023</b></p>
      <p><b>"Show Chi Love" Group Exhibition - Chicago 2020</b></p>
      <p><b>"Crossover" Group Exhibition- Philadelphia 2019</b></p>
      <p><b>“Courtside Visions” Solo Exhibition - Melbourne 2018</b></p>
      <p>
        <b>"Crossover" Group Exhibition- Philadelphia 2019</b> In 2023, he published IN THE PAINT, a 10-year retrospective art book in collaboration
        with Snap Collective, documenting his evolving body of sports-centered portraiture.
      </p>

      <p>
        Gold is also co-founder of <b>The Arts Hole</b>, a multidisciplinary studio space in Melbourne that supports collaboration across street
        art, design, and visual storytelling. His murals and collaborative projects can be found throughout Australia and internationally,
        reflecting both his technical ability and community engagement.
      </p>

      <p>
        This body of work was conceptualized in second half of 2024 and brought to life in 2025. The paintings are a reflection Kevin's
        Love for all things NBA and basketball in general while drawing inspiration from some of the most iconic trading cards in the
        hobby and interpreting those cards into his own personal style.
      </p>

      <p>
        As he continues to build bridges between visual art and global sport, Kevin Gold offers viewers a powerful, often intimate lens into
        the people who shape our cultural imagination—transcending fandom and form to create something altogether timeless.
      </p>
    </div>

    <div class="page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 2.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="description-container">
        <div class="text">
          <div>Kevin Gold</div>
          <div>Kobe PMG, 2025</div>
          <div>Acrylic on wood panel in Tasmanian wood frame</div>
          <div>32.37 x 24.5 x 1 3/4 in</div>
          <div>Subject to Availability</div>
        </div>

        <div class="logo">
          <lazy-image src="../img/grails/logo.jpg" alt="BuyNiceCards" />
        </div>
      </div>
    </div>

    <div class="page relative-page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 3.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="text">
        <div>Kevin Gold</div>
        <div>Kobe PMG, 2025</div>
        <div>(Detail)</div>
      </div>
    </div>

    <div class="page relative-page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 4.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="text">
        <div>Kevin Gold</div>
        <div>Kobe PMG, 2025</div>
        <div>(Detail)</div>
      </div>
    </div>

    <div class="page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 5.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="description-container">
        <div class="text">
          <div>Kevin Gold</div>
          <div>Kobe PMG, 2025</div>
          <div>(Installation View)</div>
        </div>

        <div class="logo">
          <lazy-image src="../img/grails/logo.jpg" alt="BuyNiceCards" />
        </div>
      </div>
    </div>

    <div class="page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 6.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="description-container">
        <div class="text">
          <div>Kevin Gold</div>
          <div>Bron Chrome Gold, 2025</div>
          <div>Acrylic on wood panel in Tasmanian wood frame</div>
          <div>32.37 x 24.5 x 1 3/4 in</div>
          <div>Subject to Availability</div>
        </div>

        <div class="logo">
          <lazy-image src="../img/grails/logo.jpg" alt="BuyNiceCards" />
        </div>
      </div>
    </div>

    <div class="page relative-page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 7.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="text" style="color: black">
        <div>Kevin Gold</div>
        <div>Bron Chrome Gold, 2025</div>
        <div>(Detail)</div>
      </div>
    </div>

    <div class="page relative-page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 8.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="text">
        <div>Kevin Gold</div>
        <div>Bron Chrome Gold, 2025</div>
        <div>(Detail)</div>
      </div>
    </div>

    <div class="page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 9.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="description-container">
        <div class="text">
          <div>Kevin Gold</div>
          <div>Bron Chrome Gold, 2025</div>
          <div>(Installation View)</div>
        </div>

        <div class="logo">
          <lazy-image src="../img/grails/logo.jpg" alt="BuyNiceCards" />
        </div>
      </div>
    </div>

    <div class="page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 10.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="description-container">
        <div class="text">
          <div>Kevin Gold</div>
          <div>MJ Ruby, 2025</div>
          <div>Acrylic on wood panel in Tasmanian wood frame</div>
          <div>32.37 x 24.5 x 1 3/4 in</div>
          <div>Subject to Availability</div>
        </div>

        <div class="logo">
          <lazy-image src="../img/grails/logo.jpg" alt="BuyNiceCards" />
        </div>
      </div>
    </div>

    <div class="page relative-page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 11.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="text">
        <div>Kevin Gold</div>
        <div>MJ Ruby, 2025</div>
        <div>(Detail)</div>
      </div>
    </div>

    <div class="page relative-page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 12.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="text">
        <div>Kevin Gold</div>
        <div>MJ Ruby, 2025</div>
        <div>(Detail)</div>
      </div>
    </div>

    <div class="page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 13.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="description-container">
        <div class="text">
          <div>Kevin Gold</div>
          <div>MJ Ruby, 2025</div>
          <div>(Installation View)</div>
        </div>

        <div class="logo">
          <lazy-image src="../img/grails/logo.jpg" alt="BuyNiceCards" />
        </div>
      </div>
    </div>

    <div class="page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 14.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="description-container">
        <div class="text">
          <div>Kevin Gold</div>
          <div>MJ Exquisite, 2025</div>
          <div>Acrylic on wood panel in Tasmanian wood frame</div>
          <div>32.37 x 24.5 x 1 3/4 in</div>
          <div>Subject to Availability</div>
        </div>

        <div class="logo">
          <lazy-image src="../img/grails/logo.jpg" alt="BuyNiceCards" />
        </div>
      </div>
    </div>

    <div class="page relative-page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 15.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="text" style="top: 32px; bottom: unset">
        <div>Kevin Gold</div>
        <div>MJ Exquisite, 2025</div>
        <div>(Detail)</div>
      </div>
    </div>

    <div class="page relative-page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 16.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="text" style="right: 32px; left: unset; color: black">
        <div>Kevin Gold</div>
        <div>MJ Exquisite, 2025</div>
        <div>(Detail)</div>
      </div>
    </div>

    <div class="page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 17.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="description-container">
        <div class="text">
          <div>Kevin Gold</div>
          <div>MJ Exquisite, 2025</div>
          <div>(Installation View)</div>
        </div>

        <div class="logo">
          <lazy-image src="../img/grails/logo.jpg" alt="BuyNiceCards" />
        </div>
      </div>
    </div>

    <div class="page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 18.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="description-container">
        <div class="text">
          <div>Kevin Gold</div>
          <div>Grails 2025</div>
          <div>(Installation View)</div>
        </div>
      </div>
    </div>

    <div class="page">
      <div class="image-container">
        <lazy-image src="../img/grails/page 19.jpg" alt="GRAILS By Kevin Gold" />
      </div>

      <div class="description-container">
        <div class="text">
          <div>Kevin Gold</div>
          <div>Studio View</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LazyImage from 'v-lazy-image';

export default {
  components: {
    LazyImage,
  },

  metaInfo: {
    title: 'GRAILS By Kevin Gold',
    meta: [
      {
        property: 'og:title',
        content: 'GRAILS By Kevin Gold',
      },
      {
        property: 'og:description',
        content: 'July 3 - August, 2025 NSCC ShowChicago, IL',
      },
    ],
  },
};
</script>

<style lang="scss" scoped>
.page {
  &:not(:first-child) {
    margin: $gp * 4 0;
  }

  .main-text {
    text-align: center;
    position: static;
    max-width: 800px;
    font-weight: bold;
    color: white;
    padding: $gp;

    > div:first-child {
      font-size: 60px;
    }

    > div:nth-child(2) {
      font-size: 32px;
      margin-bottom: $gp * .5;

      @media (max-width: 768px) {
        font-size: 24px;
      }
    }

    > div:nth-child(3) {
      font-size: 20px;
    }
  }

  .image-container {
    margin-bottom: $gp;
  }

  .description-container {
    display: flex;
    justify-content: space-between;

    .text {
      font-size: 14px;
      line-height: 1.5;

      @media (max-width: 768px) {
        font-size: 12px;
      }
    }

    .logo {
      width: 150px;
      height: 150px;

      @media (max-width: 768px) {
        width: 100px;
        height: 100px;
      }
    }
  }

  &.relative-page {
    position: relative;

    .text {
      position: absolute;
      bottom: $gp * 2;
      left: $gp * 2;
      color: white;
      font-weight: bold;
      font-size: 18px;

      @media (max-width: 768px) {
        font-size: 14px;
        bottom: 16px;
        left: 16px;
      }
    }
  }
}
</style>
